import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const FooterSocialLinks = () => {
  const { t } = useLanguage();

  const socialLinks = [
    {
      name: 'Instagram',
      icon: 'fab fa-instagram',
      url: 'https://www.instagram.com/anadolulezzetleri'
    },
    {
      name: 'Facebook',
      icon: 'fab fa-facebook-f',
      url: 'https://www.facebook.com/anadolulezzetleri'
    },
    {
      name: 'WhatsApp',
      icon: 'fab fa-whatsapp',
      url: 'https://wa.me/32412345678'
    },
    {
      name: 'YouTube',
      icon: 'fab fa-youtube',
      url: 'https://www.youtube.com/anadolulezzetleri'
    }
  ];

  return (
    <div className="flex items-center space-x-3">
      {socialLinks.map((social) => (
        <a
          key={social.name}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/40 hover:text-amber-500 hover:border-amber-500 hover:bg-amber-600/5 transition-all duration-300"
          title={`${t('followUsOn')} ${social.name}`}
        >
          <i className={social.icon}></i>
        </a>
      ))}
    </div>
  );
};

export default FooterSocialLinks;
